<template>
  <div class="wrap wrap-intel">
    <div class="banner">
      <img src="@/assets/images/banner_12.png" class="img-fluid">
      <div class="banner-info">
        <div class="left">
          <h2>防腐蚀转轮除湿系统</h2>
          <p style="line-height: 2;font-size: 16px">防腐蚀转轮除湿系统通过机械按钮+湿度控制的方式严格控制合成室内的温湿度。</p>
        </div>
        <div class="img_a" style="width:35%"><img src="@/assets/img/设备及原料/仪器设备/除湿系统.png" width="100%" class="product"></div>
      </div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container container1">
      <div class="c-title">产品特点</div>
      <el-row :gutter="90" type="flex" align="middle">
        <el-col :span="10">
          <div class="tc"><img src="@/assets/img/设备及原料/仪器设备/除湿系统.png" width="260"></div>
        </el-col>
        <el-col :span="14" class="right-col">
          <ul class="lists">
            <li>处理及再生过滤网采用G4 初效铝合金，具有可清洗，防腐蚀等特点</li>
            <li>产生噪音不高于60DB</li>
            <li>再生加热方式采用PTC+SCR精准控温</li>
          </ul>
        </el-col>
      </el-row>
    </section>
    <section class="container">
       <div class="dispose">
        <div class="title">标准配置</div>
        <el-row class="text-row">
          <el-col :span="24" class="list-item"><div><span class="circle"></span>防腐蚀卷轮除湿系统，1套</div></el-col>
        </el-row>
      </div>
   </section>
    <section class="container">
      <div class="c-title">性能参数</div>
      <el-row :gutter="40">
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">除湿量</td>
              <td>3kg/h</td>
            </tr>
            <tr>
              <td>电压</td>
              <td>220v/50Hz</td>
            </tr>
          </table>
        </el-col>
        <el-col :span="12">
          <table class="table">
            <tr>
              <td style="width:40%">再生风风量</td>
              <td>200m3/h（150Pa） Φ100mm</td>
            </tr>
            <tr>
              <td>处理风风量</td>
              <td>600m3/h（200Pa） Φ160mm</td>
            </tr>
          </table>
        </el-col>
      </el-row>
    </section>
  </div>
</template>
<style scoped>
@import url("../../assets/akta.css");
</style>
<style scoped lang="scss">
  .lists{
    display: unset !important;
    li{
      text-align: left;
    }
  }
  /deep/.right-col{
    padding: 0 !important;
  }
  .center-ele{
  margin-left: 100px;
  text-align: center;
  font-weight: bold;
}
.desc-ch{
  margin-top:-35px;
}
.desc-eh{
  margin-top:-16px;
}
.text-desc-list{
  padding-left: 26px;
}
.list-item{
  position: relative;
  padding-left: 20px !important;
}
.circle{
  display: inline-block;
  background: #014492;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 20px;
  position: absolute;
  left: 0px;
  top:4px;
}
.text-row{
  padding:10px 0;
}
</style>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/intel/DHFSYS.vue